module.exports = __webpack_public_path__ + "static/fish-30-9d226dea59b35c697a667e2787a2bf21.jpg";